import { useEffect, useState } from "react";
import { Button, Card, Empty } from "antd";
import { CircleCheckBig, CircleX, MapPin,ChevronRight } from "lucide-react";

import { fetchContractor } from "sr/helpers/apiFunctions/contractor/fetchContractor";
import { getCustomerLocation } from "sr/utils/api/company/customer/getCustomerLocation";
import { assignContractorLocation } from "sr/utils/api/company/workorder/assignContractorLocation";
import { removeContractorLocation } from "sr/utils/api/company/workorder/removeContractorLocation";

function Step2(props: any) {
  const [isLoading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(false);

  const [data, setData] = useState<any>({});
  const [locations, setLocations] = useState<any>({});

  useEffect(() => {
    getContractorDetails();
    getLocation();
  }, []);

  const getContractorDetails = async () => {
    try {
      let params = `?id=${props?.data?.id}`;
      await fetchContractor({
        id: props?.data?.id,
        setData: (data: any) => setData(data),
        setLoader: (status: any) => {},
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setLoading2(false);
    }
  };

  const getLocation = async () => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("company_id", String(props.company_id));
      queryParams.append("alldata", "true");
      queryParams.append("status!", "deleted");
      let locData: any = [];
      const response = await getCustomerLocation(queryParams);
      if (response?.data?.length) {
        response?.data?.map((item: any) => {
          locData.push({
            label: item?.name,
            more: item?.address,
            addressLine1: item?.address?.address_line_1,
            value: item?.id,
          });
        });
      }
      setLocations(locData);
    } catch (err) {
      console.log("err", err);
    }
  };

  const assign = async (id: any) => {
    try {
      setLoading2(id);
      const payLoad = {
        contractor_id: props?.data?.id,
        customer_location_ids: [id],
      };
      const response = await assignContractorLocation(payLoad);
      console.log("response", response);
      getContractorDetails();
      setLoading2(null);
    } catch (err) {
      console.log("err", err);
      setLoading2(null);
    }
  };

  const unassign = async (id: any) => {
    try {
      setLoading2(id);
      const payLoad = {
        contractor_id: props?.data?.id,
        customer_location_ids: id,
      };
      const response = await removeContractorLocation(payLoad);
      getContractorDetails();
      setLoading2(null);
    } catch (err) {
      console.log("err", err);
      setLoading2(null);
    }
  };

  return (
    <div className="mt-6 mx-auto max-w-4xl pb-40">
      <Card
        title="Assign Locations"
        loading={isLoading}
        headStyle={{ padding: 10 }}
      >
        {locations?.length ? (
          locations?.map((item: any, index: number) => {
            const { address_line_2, city, state, postal, country } =
              item?.more || {};
            const addressParts = [address_line_2, city, state, postal, country];
            const address = addressParts.filter(Boolean).join(", ");
            const checkAssigned = data?.customer_location_ids?.some(
              (item2: any) => item2?._id === item?.value
            );
            return (
              <div key={item?.key}
               className={`flex  gap-4 ${
                locations?.length !== index + 1 && "border-b mb-4 pb-4"
              } `}>
                <div className="bg-slate-100 w-10 h-10 flex items-center justify-center rounded">
                  <MapPin
                    size={20}
                    color={checkAssigned ? "#ff39b3" : "grey"}
                  />
                </div>
                <div className="flex-1">
                  <div className="font-semibold text-[16px]">{item?.label}</div>
                  <div className="text-gray-500">{item?.addressLine1}</div>
                  <div className="text-gray-500">{address}</div>
                </div>
                <div>
                  <Button
                    danger={checkAssigned ? true : false}
                    type={checkAssigned ? null : "primary"}
                    onClick={() =>
                      checkAssigned
                        ? unassign(item?.value)
                        : assign(item?.value)
                    }
                    loading={loading2 === item?.value}
                  >
                    {checkAssigned ? "Unassign" : "Assign"}
                    {checkAssigned ? (
                      <CircleX size={15} />
                    ) : (
                      <CircleCheckBig size={15} />
                    )}
                  </Button>
                </div>
              </div>
            );
          })
        ) : (
          <Empty description="No locations assigned" />
        )}
      </Card>
      <div className="fixed bottom-0 left-0 right-0 bg-white backdrop-blur-sm border-t border-gray-200 z-1000 p-2 !pl-0 sm:!pl-[200px]">
        <div className="flex items-center mx-auto sm:max-w-4xl">
          <div>
            <Button
              size="large"
              danger
              className="!px-10"
              onClick={() => props?.onBack()}
            >
              Back
            </Button>
          </div>
          <div className="flex-1"></div>
          <div>
            <Button
              size="large"
              type="primary"
              className="!px-10"
              onClick={() => props?.onChange()}
            >
              Next <ChevronRight size={20}/>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Step2;
